import './main-loader.scss';

import { LoadingOutlined } from '@/media/antd-icons';

interface IProps {
  fullWidth?: boolean;
  fullScreen?: boolean;
  blur?: boolean;
}

const MainLoader: React.FC<IProps> = ({ fullWidth, fullScreen, blur }) => {
  const rootClasses = [
    'main-loader',
    fullWidth ? 'main-loader--full-width' : '',
    fullScreen ? 'main-loader--fullscreen' : '',
    blur ? 'main-loader--blur' : ''
  ].join(' ');

  return (
    <div className={rootClasses}>
      <LoadingOutlined className="main-loader__spinner" />
    </div>
  );
};

export default MainLoader;
